import type { MerchantRoutes } from "@redotech/redo-merchant-app-common/merchant-routes";

/**
 * Resolves the analytics reports base href for the product section the given
 * path belongs to. Used by section-agnostic surfaces (e.g. the global Ask Redo
 * panel) so a report opened while working in a section stays in that section
 * rather than ejecting the user into Returns.
 */
export function getAnalyticsReportsHrefForPath(
  pathname: string,
  routes: MerchantRoutes,
): string {
  if (pathname.startsWith(`${routes.conversionBaseUrl}/`)) {
    return routes.conversionAnalyticsReportsHref;
  }
  if (pathname.startsWith(`${routes.marketingBaseUrl}/`)) {
    return routes.marketingAnalyticsReportsHref;
  }
  if (pathname.startsWith(`${routes.inventoryManagementBaseUrl}/`)) {
    return routes.inventoryAnalyticsReportsHref;
  }
  return routes.analyticsReportsHref;
}
